import { Button } from "primereact/button";
import { useCallback, useState } from "react";
import { Carousel } from "primereact/carousel";
import { classNames } from "primereact/utils";
import DialogCourseCarouselItem from "./DialogCourseCarouselItem";
import CourseCarouselImage from "./CourseCarouselImage";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";
import { TEXT_NORMAL } from "../../style";

export default function CourseCarousel({ className = "", course, setCourse }) {
    const images = course?.carousel || [];

    const [dialogCarouselItem, setDialogCarouselItem] = useState({
        visible: false,
    });

    const closeDialogCarouselItem = useCallback(() => {
        setDialogCarouselItem((prev) => ({ ...prev, visible: false }));
    }, []);

    const onAdded = useCallback(
        (item) => {
            setCourse((prev) => ({
                ...prev,
                carousel: [...(prev?.carousel || []), item],
            }));
        },
        [setCourse],
    );

    const onUpdated = useCallback(
        (item) => {
            setCourse((prev) => ({
                ...prev,
                carousel: (prev?.carousel || []).map((carouselItem) => (carouselItem.id === item.id ? item : carouselItem)),
            }));
        },
        [setCourse],
    );

    const onDeleted = useCallback(
        (id) => {
            setCourse((prev) => ({
                ...prev,
                carousel: (prev?.carousel || []).filter((item) => item.id !== id),
            }));
        },
        [setCourse],
    );

    const onEdit = useCallback(
        (item) => {
            setDialogCarouselItem({
                visible: true,
                courseId: course?.id,
                closeDialog: closeDialogCarouselItem,
                onUpdated,
                ...item,
            });
        },
        [closeDialogCarouselItem, course?.id, onUpdated],
    );

    const itemTemplate = useCallback(
        (item) => <CourseCarouselImage {...item} onDeleted={onDeleted} onEdit={onEdit} />,
        [onDeleted, onEdit],
    );

    return (
        <div className={`flex flex-column ${className}`}>
            {!!images?.length ? (
                <Carousel
                    pt={{ indicators: classNames("py-1") }}
                    circular
                    autoplayInterval={5000}
                    showNavigators={false}
                    value={images}
                    numVisible={1}
                    numScroll={1}
                    itemTemplate={itemTemplate}
                />
            ) : (
                <img className="w-full h-8rem block" src={course?.image} alt={course?.title} />
            )}

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_COURSE}>
                <div className="flex justify-content-center">
                    <Button
                        className="mt-1"
                        icon="pi pi-plus"
                        severity="warning"
                        aria-label="Add carousel item"
                        onClick={() =>
                            setDialogCarouselItem({
                                visible: true,
                                courseId: course?.id,
                                closeDialog: closeDialogCarouselItem,
                                onAdded,
                            })
                        }
                        pt={{
                            icon: { className: TEXT_NORMAL },
                        }}
                    />
                </div>
            </HasRequiredAuthority>

            {dialogCarouselItem?.visible && (
                <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_COURSE}>
                    <DialogCourseCarouselItem {...dialogCarouselItem} />
                </HasRequiredAuthority>
            )}
        </div>
    );
}
